import { ImagingReportRowData } from "../tables/notes/imaging-reports-rows";
import { FilterOption, appendNotSpecifiedFilterOption } from "./filter-helpers";

/**
 * Create filter options for ImagingReport data based on actual values
 */
export function createImagingReportFilters(rows: ImagingReportRowData[]): FilterOption[] {
  const filters: FilterOption[] = [];

  if (!rows || rows.length === 0) {
    return filters;
  }

  // Extract unique imaging modalities and body regions
  const modalities = new Set<string>();
  const bodyRegions = new Set<string>();

  rows.forEach(row => {
    if (row.imagingModality && row.imagingModality !== "-") {
      // Split comma-separated values and add each one
      row.imagingModality.split(",").forEach(modality => {
        const trimmed = modality.trim();
        if (trimmed) {
          modalities.add(trimmed);
        }
      });
    }
    if (row.bodyRegion && row.bodyRegion !== "-") {
      // Split comma-separated values and add each one
      row.bodyRegion.split(",").forEach(region => {
        const trimmed = region.trim();
        if (trimmed) {
          bodyRegions.add(trimmed);
        }
      });
    }
  });

  // Create imaging modality filters
  Array.from(modalities)
    .sort()
    .forEach(modality => {
      filters.push({
        label: modality,
        groupLabel: "Imaging Modality",
        value: `imagingModality:${modality}`,
      });
    });

  // Create body region filters
  Array.from(bodyRegions)
    .sort()
    .forEach(region => {
      filters.push({
        label: region,
        groupLabel: "Body Region",
        value: `bodyRegion:${region}`,
      });
    });

  // Automatically add "Not Specified" for each group
  return appendNotSpecifiedFilterOption(filters);
}
